import React from 'react';
import { render } from '@testing-library/react';
import { DataList } from './DataList';

describe('DataList', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<DataList
				items={[
					{ id: '987ABCD', desc: '1' },
					{ id: '654ABCD', desc: '2' },
					{ id: '643ABCD', desc: '3' },
				]}
				header={[
					<DataList.HeaderCell
						key={0}
						name="id"
						content="Contact ID"
					/>,
					<DataList.HeaderCell
						key={1}
						name="desc"
						content="Description"
					/>,
				]}
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
